"use strict";

/**
* @ngdoc directive
* @name nms.directive:groupBasic
* @description Diretiva para criar a tab de informações básicas de grupo.
*
* Atributos:
* # id               - Obrigatório      - Identificador. Utilizado para a criação de ids no html de forma a evitar duplicidade
*                                       quando diretiva é usada mais de uma vez na página.
*
* # owner            - Obrigatório      - Objeto utilizado para comunicação entre a diretiva e seu pai, contendo o modelo de
*                                       dados.
*                    - Estrutura        - {model: {}}
*
* # groupNamesInUse  - Obrigatório      - Array de nomes de grupos já cadastrados.
*
*/
var app = angular.module("nms");

app.directive("groupBasic", function() {
    return {
        restrict: "E",
        templateUrl: "templates/features/management/groups/basic/basic.html",
        scope: {
            id: "@",
            owner: "=",
            groupNamesInUse: "="
        }
    };
});
